"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Report = void 0;
const core_api_1 = require("@ikegps/core-api");
const core_shared_1 = require("@ikegps/core-shared");
const i18n_1 = require("../../../i18n");
const store_1 = require("../../../store");
const DataGrid_1 = require("../components/DataGrid");
const ImageGrid_1 = require("../components/ImageGrid");
const ImageWithTitle_1 = require("../components/ImageWithTitle");
const TitleBar_1 = require("../components/TitleBar");
const DataExtractor_1 = require("../DataExtractor");
const ReportHelpers_1 = require("../ReportHelpers");
const ReportBase_1 = require("./ReportBase");
class Report extends ReportBase_1.ReportBase {
    constructor(poles) {
        super(poles);
    }
    buildPDF() {
        this.poles.forEach((pole, i) => {
            const job = store_1.AppStore.Tag.get(pole.jobId);
            const fullImages = [];
            const imageGroups = {};
            const tagArr = [];
            const subformArray = [];
            // Title
            this.nodes.push(new TitleBar_1.TitleBar(pole.title || (0, i18n_1.Translate)(i18n_1.T.COLLECTION_MISSING_TITLE), job.name, i + 1, this.poles.length));
            // Data grid of items outside of subforms
            pole.forEachField((field) => {
                if (field.parent.parent == null) {
                    if (field.hasValue() &&
                        field.schema.type !== core_api_1.IkeFieldType.FORM &&
                        field.schema.type !== core_api_1.IkeFieldType.IMAGE &&
                        field.schema.type !== core_api_1.IkeFieldType.TRUE_SIZE) {
                        const extractedValue = DataExtractor_1.DataExtractor.createPrintableValue(field);
                        tagArr.push([extractedValue.title, extractedValue.value]);
                    }
                    if (field instanceof core_shared_1.CollectionModelFieldSubForm) {
                        subformArray.push(...(0, ReportHelpers_1.extractSubforms)(pole, field, this.images));
                    }
                    if (field instanceof core_shared_1.CollectionModelFieldTrueSize) {
                        const captures = field.getCaptures();
                        captures.forEach((capture) => {
                            var _a;
                            if (!(0, ReportHelpers_1.isCaptureHidden)(pole, capture.objectId)) {
                                const imageReferenceString = (0, ReportHelpers_1.captureReferenceString)(pole, capture);
                                this.images[imageReferenceString] = (0, ReportHelpers_1.compositeURL)(pole, capture);
                                const imgReference = { reference: imageReferenceString };
                                // If a capture has measurements, then it has the timestamp built into the photo
                                if ((0, ReportHelpers_1.hasUserMeasurement)(pole, capture.objectId)) {
                                    fullImages.push(new ImageWithTitle_1.ImageWithTitle(field.schema.displayName, imgReference));
                                }
                                else {
                                    imgReference.timeStamp = new Date(capture.createdAt);
                                }
                                if (!imageGroups[field.schema.displayName]) {
                                    imageGroups[field.schema.displayName] = [];
                                }
                                (_a = imageGroups[field.schema.displayName]) === null || _a === void 0 ? void 0 : _a.push(imgReference);
                            }
                        });
                    }
                    if (field instanceof core_shared_1.CollectionModelFieldImage) {
                        const captures = field.getCaptures();
                        captures.forEach((capture) => {
                            var _a;
                            if (!(0, ReportHelpers_1.isCaptureHidden)(pole, capture.objectId)) {
                                const imageReferenceString = (0, ReportHelpers_1.captureReferenceString)(pole, capture);
                                // For Image fields, use composite if crop is set, otherwise use medium
                                const hasCrop = pole.getCropParameterState(capture.objectId).useInExportCorrections();
                                this.images[imageReferenceString] = hasCrop ? (0, ReportHelpers_1.compositeURL)(pole, capture) : capture.medium.url;
                                if (!imageGroups[field.schema.displayName]) {
                                    imageGroups[field.schema.displayName] = [];
                                }
                                (_a = imageGroups[field.schema.displayName]) === null || _a === void 0 ? void 0 : _a.push({
                                    reference: imageReferenceString,
                                    timeStamp: new Date(capture.createdAt),
                                });
                            }
                        });
                    }
                }
            });
            this.nodes.push(new DataGrid_1.DataGrid(tagArr));
            this.nodes.push(new ImageGrid_1.ImageGrid(imageGroups));
            // Subforms
            subformArray.forEach((subform) => {
                this.nodes.push(subform);
            });
            // Full size composite images
            this.nodes.push(...fullImages);
        });
    }
}
exports.Report = Report;
//# sourceMappingURL=Report.js.map